jQuery( document ).foundation();

import "slick-carousel";
import "slick-lightbox";

import "./parts/header.js";
import "./parts/icons-descriptions.js";
import "./blocks/steps-slider.js";

import { throttle, debounce } from "./utilities/limiters";

// Deferring out laoding of CF7 recaptcha v3
var captchaLoaded = false;

function loadRecaptcha() {
  if ( captchaLoaded ) {
    return;
  }

  const head = document.getElementsByTagName( 'head' )[0];
  const recaptchaScript = document.createElement( 'script' );
  const cf7script = document.createElement( 'script' );
  const recaptchaKey = '6LfNi7IZAAAAABw0VZChRTTpbxRDeRKTPvOO3n8I';

  recaptchaScript.type = 'text/javascript';
  recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + recaptchaKey + '&#038;ver=3.0';

  cf7script.type = 'text/javascript';
  cf7script.text = "!function(t,e){var n={execute:function(e){t.execute(\"" + recaptchaKey + "\",{action:e}).then(function(e){for(var t=document.getElementsByTagName(\"form\"),n=0;n<t.length;n++)for(var c=t[n].getElementsByTagName(\"input\"),a=0;a<c.length;a++){var o=c[a];if(\"_wpcf7_recaptcha_response\"===o.getAttribute(\"name\")){o.setAttribute(\"value\",e);break}}})},executeOnHomepage:function(){n.execute(e.homepage)},executeOnContactform:function(){n.execute(e.contactform)}};t.ready(n.executeOnHomepage),document.addEventListener(\"change\",n.executeOnContactform,!1),document.addEventListener(\"wpcf7submit\",n.executeOnHomepage,!1)}(grecaptcha,{homepage:\"homepage\",contactform:\"contactform\"});";
  head.appendChild( recaptchaScript );

  // Add CF7 Script AFTER Recaptcha. Timeout ensures the loading sequence.
  setTimeout( function() {
    head.appendChild( cf7script );
  }, 200 );

  captchaLoaded = true;
}

jQuery( document ).ready( function() {
  jQuery( '.wpcf7-form input' ).on( 'focus', function() {
    loadRecaptcha();
  } );

  setTimeout( () => {
    loadRecaptcha();
  }, 5000 );
} );

jQuery( '.topImage' ).slick( {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoPlay: false,
  asNavFor: '.topImageNav'
} );
jQuery( '.topImageNav' ).slick( {
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.topImage',
  autoPlay: false,
  dots: false,
  fade: false,
  arrows: true,
  centerMode: true,
  centerPadding: 0,
  prevArrow: '<svg class="slick-arrow slick-prev" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
  nextArrow: '<svg class="slick-arrow slick-next" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
} );

jQuery( '.service-card-slider-4' ).slick( {
  dots: true,
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoPlay: true,
  autoplaySpeed: 2500,
  arrows: false,
  prevArrow: '<svg class="slick-arrow slick-prev" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
  nextArrow: '<svg class="slick-arrow slick-next" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
} );

jQuery( '.testimonials-slider' ).slick( {
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  adaptiveHeight: false,
  dots: false,
  fade: true,
  centerMode: true,
  prevArrow: jQuery( '#testimonials-prev' ),
  nextArrow: jQuery( '#testimonials-next' )
} );


jQuery( '.service-card-slider' ).slick( {
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  dots: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 639,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
} );

jQuery( '.blog-slider' ).slick( {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,
  fade: false,
  prevArrow: '<svg class="slick-arrow slick-prev" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
  nextArrow: '<svg class="slick-arrow slick-next" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#009CD8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
} );

jQuery( '.main-slide' ).slick( {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  autoPlay: false,
  asNavFor: '.nav-slide'
} );
jQuery( '.nav-slide' ).slick( {
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.main-slide',
  autoPlay: true,
  dots: false,
  fade: false,
  arrows: true,
  centerPadding: 0,
  prevArrow: '<svg class="slick-arrow slick-prev" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#A8A8A8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
  nextArrow: '<svg class="slick-arrow slick-next" width="16px" height="26px" viewBox="0 0 16 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Sections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="Service-MOBILE" transform="translate(-389.000000, -368.000000)" stroke="#A8A8A8" stroke-width="4.9"><polyline id="Stroke-1" transform="translate(397.000000, 381.000000) rotate(-90.000000) translate(-397.000000, -381.000000) " points="407 376 397.00003 386 387 376"></polyline></g></g></svg>',
} );

var pathname = window.location.pathname;
if ( pathname == '/shop/' ) {
  jQuery( '.shop-link' ).css( 'display', 'none' );
}
if ( pathname !== '/shop/' ) {
  jQuery( ".shop-link" ).click( function() {
    jQuery( 'html, body' ).animate( {
      scrollTop: jQuery( ".shop-section" ).offset().top - 20
    }, 1000 );
  } );
}

jQuery( ".open-form-inner" ).click( function() {
  jQuery( "#contact" ).addClass( "open" );
  jQuery( ".open-form" ).addClass( "closed" );
  jQuery( ".form-holder" ).addClass( "open" );
  jQuery( ".close-contact" ).addClass( "open" );
} );

jQuery( ".menu-item-has-children" ).click( function() {
  jQuery( "ul.sub-menu" ).toggleClass( "open" );
  jQuery( ".dropdown-arrow" ).toggleClass( "open" );
} );

jQuery( ".open-form-inner" ).click( function() {
  if ( jQuery( window ).width() > 749 ) {
    jQuery( 'html, body' ).animate( {
      scrollTop: jQuery( "#contact" ).offset().top - 80
    }, 1000 );
  } else {

  }
} );

jQuery( ".close-contact" ).click( function() {
  jQuery( ".open-form" ).removeClass( "closed" );
  jQuery( ".form-holder" ).removeClass( "open" );
  jQuery( "#contact" ).removeClass( "open" );
  jQuery( ".close-contact" ).removeClass( "open" );
} );

jQuery( "#contact .consent-column" ).on( "click touch", function() {
  if ( jQuery( "#contact [type=checkbox]:checked" ).length ) {
    jQuery( "#contact [type=checkbox]" ).attr( "checked", false );
  } else {
    jQuery( "#contact [type=checkbox]" ).attr( "checked", true );
  }
} );

jQuery( function() {
  const downs = document.querySelectorAll( '.down' );
  downs.forEach( down => {
    down.addEventListener( 'click', () => {
      const nextSection = down.closest( 'section, .section' ).nextElementSibling;
      nextSection.scrollIntoView( {
        behavior: "smooth"
      } );
    } );
  } );
} );

jQuery( ".shop-link" ).click( function() {
  jQuery( 'html, body' ).animate( {
    scrollTop: jQuery( ".shop-section" ).offset().top - 20
  }, 1000 );
} );

jQuery( ".contact-link" ).click( function() {
  if ( jQuery( window ).width() > 749 ) {
    jQuery( 'html, body' ).animate( {
      scrollTop: jQuery( "#contact" ).offset().top - 80
    }, 1000 );
    jQuery( "#contact" ).addClass( "open" );
    jQuery( ".open-form" ).addClass( "closed" );
    jQuery( ".form-holder" ).addClass( "open" );
    jQuery( ".close-contact" ).addClass( "open" );
  } else {
    jQuery( 'html, body' ).animate( {
      scrollTop: jQuery( "#contact" ).offset().top - 60
    }, 1000 );
  }
} );

jQuery( 'img.svg' ).each( function() {
  var $img = jQuery( this );
  var imgID = $img.attr( 'id' );
  var imgClass = $img.attr( 'class' );
  var imgURL = $img.attr( 'src' );
  jQuery.get( imgURL, function( data ) {
    var $svg = jQuery( data ).find( 'svg' );
    if ( typeof imgID !== 'undefined' ) {
      $svg = $svg.attr( 'id', imgID );
    }
    if ( typeof imgClass !== 'undefined' ) {
      $svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
    }
    $svg = $svg.removeAttr( 'xmlns:a' );
    if ( !$svg.attr( 'viewBox' ) && $svg.attr( 'height' ) && $svg.attr( 'width' ) ) {
      $svg.attr( 'viewBox', '0 0 ' + $svg.attr( 'height' ) + ' ' + $svg.attr( 'width' ) );
    }
    $img.replaceWith( $svg );
  }, 'xml' );
} );

var acc = document.getElementsByClassName( "faq-accordion" );
var i;
for ( i = 0; i < acc.length; i++ ) {
  acc[i].addEventListener( "click", function() {
    this.classList.toggle( "active" );
    var panel = this.nextElementSibling;
    if ( panel.style.maxHeight ) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  } );
}

jQuery( ".wpcf7-form" ).on( 'keyup click', function( event ) {
  var name = jQuery( 'span.your-name input' ).val();
  var phone = jQuery( 'span.your-phone input' ).val();
  var email = jQuery( 'span.your-email input' ).val();
  var message = jQuery( 'span.your-message textarea' ).val();
  if ( name != 0 ) {
    jQuery( ".group.your-name label" ).addClass( "valid" );
    jQuery( ".group.your-name" ).addClass( "valid" );
  } else {
    jQuery( ".group.your-name label" ).removeClass( "valid" );
    jQuery( ".group.your-name" ).removeClass( "valid" );
  }
  if ( phone != 0 ) {
    jQuery( ".group.your-phone label" ).addClass( "valid" );
    jQuery( ".group.your-phone" ).addClass( "valid" );
  } else {
    jQuery( ".group.your-phone label" ).removeClass( "valid" );
    jQuery( ".group.your-phone" ).removeClass( "valid" );
  }
  if ( email != 0 ) {
    jQuery( ".group.your-email label" ).addClass( "valid" );
    jQuery( ".group.your-email" ).addClass( "valid" );
  } else {
    jQuery( ".group.your-email label" ).removeClass( "valid" );
    jQuery( ".group.your-email" ).removeClass( "valid" );
  }
  if ( message != 0 ) {
    jQuery( ".group.your-message label" ).addClass( "valid" );
    jQuery( ".group.your-message" ).addClass( "valid" );
  } else {
    jQuery( ".group.your-message label" ).removeClass( "valid" );
    jQuery( ".group.your-message" ).removeClass( "valid" );
  }
} );

function init() {
  var imgDefer = document.getElementsByTagName( 'img' );
  for ( var i = 0; i < imgDefer.length; i++ ) {
    if ( imgDefer[i].getAttribute( 'data-src' ) ) {
      imgDefer[i].setAttribute( 'src', imgDefer[i].getAttribute( 'data-src' ) );
    }
  }
}
window.onload = init;

jQuery( document ).ready( function() {
  jQuery( ".quantity [type=number]" ).val( 1 );
} );

jQuery( document ).ready( function() {
  jQuery( ".woocommerce-thankyou-order-received" ).html( 'Thank you. Your order has been received. We aim to have orders ready for collection within two working days and we will send you an "Order Complete" email when your order is ready for collection.' );
} );

jQuery( function( $ ) {
  /* when product quantity changes, update quantity attribute on add-to-cart button */
  jQuery( "form.cart" ).on( "change", "input.qty", function() {
    if ( this.value === "0" )
      this.value = "1";
    jQuery( this.form ).find( "button[data-quantity]" ).data( "quantity", this.value );
  } );
  /* remove old "view cart" text, only need latest one thanks! */
  jQuery( document.body ).on( "adding_to_cart", function() {
    jQuery( "a.added_to_cart" ).remove();
  } );
} );

jQuery( window ).on( 'load resize', debounce( function() {
  Foundation.reInit( 'equalizer' );
}, 200 ) );

window.addEventListener( 'scroll', throttle( function() {
  const isAboveFooter = jQuery( window ).scrollTop() + jQuery( window ).height() < jQuery( '.testimonial' ).offset().top;
  const isOffsetFromTop = jQuery( window ).scrollTop() > 400;
  if ( isAboveFooter && isOffsetFromTop ) {
    jQuery( '.sticky-popout-emergency' ).removeClass( 'invisible' );
  } else {
    jQuery( '.sticky-popout-emergency' ).addClass( 'invisible' );
  }
}, 100 ), { passive: true } );